var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneSlashOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1933 2.88304C9.98848 2.3266 10.9574 2 12 2C14.7062 2 16.9 4.19381 16.9 6.9V9.91757C16.9 10.4146 16.497 10.8176 16 10.8176C15.5029 10.8176 15.1 10.4146 15.1 9.91757V6.9C15.1 5.18792 13.7121 3.8 12 3.8C11.3385 3.8 10.7278 4.00618 10.2253 4.35782C9.81805 4.6428 9.25689 4.54368 8.97191 4.13644C8.68693 3.72919 8.78605 3.16802 9.1933 2.88304Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09998 11.1C7.09998 13.8062 9.29378 16 12 16C13.0533 16 14.0298 15.6669 14.8286 15.1014L16.2776 16.5504C15.089 17.4609 13.6074 18 12 18C9.38982 18 7.10645 16.5764 5.87947 14.4502C5.63104 14.0197 5.08064 13.872 4.65012 14.1205C4.21961 14.3689 4.072 14.9193 4.32043 15.3498C5.71186 17.7611 8.19835 19.4607 11.1 19.7547V22.1C11.1 22.5971 11.5029 23 12 23C12.497 23 12.9 22.5971 12.9 22.1V19.7546C14.6545 19.5768 16.2584 18.8847 17.5592 17.832L19.3636 19.6364C19.7151 19.9878 20.2849 19.9878 20.6364 19.6364C20.9878 19.2849 20.9878 18.7151 20.6364 18.3636L5.63637 3.36358C5.2849 3.01211 4.71505 3.01211 4.36358 3.36358C4.01211 3.71505 4.01211 4.2849 4.36358 4.63637L7.09998 7.37277V11.1ZM8.89998 11.1C8.89998 12.8121 10.2879 14.2 12 14.2C12.5551 14.2 13.0757 14.0546 13.5263 13.7991L8.89998 9.17277V11.1Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneSlashOutline);
export default __webpack_public_path__ + "static/media/microphone_slash_outline.51aa19da186656382475d945742f9eef.svg";
export { ForwardRef as ReactComponent };